// extracted by mini-css-extract-plugin
export default {"modal":"EditAddress_modal__JmKTo","checkBox":"EditAddress_checkBox__R+4wy"};